<template>
	<div v-if="context.taetigkeitsbereiche">
		<nk-wrapper
			v-for="(
				taetigkeitsbereich, taetigkeitsbereicheIndex
			) in context.taetigkeitsbereiche"
			:key="`taetigkeitsbereiche-${taetigkeitsbereicheIndex}`"
			spacing="lg"
		>
			<section>
				<nk-title size="xl" tag="h2">
					{{ taetigkeitsbereich.taetigkeitsbereiche }}
				</nk-title>
				<nk-divider />
				<nk-row vertical-gutter="3">
					<nk-col
						v-for="(rat, ratIndex) in taetigkeitsbereich.raete"
						:key="`rat-${ratIndex}`"
						cols="full"
						sm="6/12"
						:md="!rat.bild ? '4/12' : null"
					>
						<nk-row vertical-gutter="2" gutter="3">
							<nk-col v-if="rat.bild" cols="12" lg="4/12" xl="4/12">
								<nk-link
									v-if="
										rat.taetigkeitsbereiche_alle.length && options.detail_link
									"
									:link="rat.taetigkeitsbereiche_alle[0].detailURL"
								>
									<nk-image
										v-if="rat.bild"
										:src="rat.bild"
										:alt="rat.bildtext"
										:copyright="rat.bildcopyright"
										ar="1:1"
										image-class="w-full"
									/>
									<nk-image
										v-else
										src="/static-images/nk-layout/person-placeholder.png"
										:alt="`Platzhalterbild für ${rat.vorname} ${rat.nachname}`"
										ar="1:1"
										image-class="w-full"
									/>
								</nk-link>
								<nk-image
									v-else-if="rat.bild"
									:src="rat.bild"
									:alt="rat.bildtext"
									:copyright="rat.bildcopyright"
									ar="1:1"
									image-class="w-full"
								/>
								<nk-image
									v-else
									src="/static-images/nk-layout/person-placeholder.png"
									:alt="`Platzhalterbild für ${rat.vorname} ${rat.nachname}`"
									ar="1:1"
									image-class="w-full"
								/>
							</nk-col>
							<nk-col cols="full" lg="auto">
								<nk-link
									v-if="
										rat.taetigkeitsbereiche_alle.length && options.detail_link
									"
									:link="rat.taetigkeitsbereiche_alle[0].detailURL"
								>
									<nk-title size="lg" tag="h3" no-margin>
										{{ rat.vorname }} {{ rat.nachname }}
									</nk-title>
								</nk-link>
								<nk-title v-else size="lg" tag="h3" no-margin>
									{{ rat.vorname }} {{ rat.nachname }}
								</nk-title>
								<nk-text v-if="rat.raete_zuordnung.funktion.length">
									{{ rat.raete_zuordnung.funktion }}
								</nk-text>
								<nk-address
									variant="vertical"
									v-bind="{...rat.kontakt, ...rat.adresse}"
									:hide-anfahrt="hideAnfahrt"
								/>
							</nk-col>
						</nk-row>
					</nk-col>
				</nk-row>
			</section>
		</nk-wrapper>
	</div>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

/**
 * @prop {array} context.raete
 * @prop {boolean} options.hideAnfahrt
 * @prop {boolean} options.showFunktion
 * @prop {boolean} options.showTaetigkeitsbereiche
 */
export default {
	name: 'NkTemplateRaeteUebersicht',

	mixins: [TemplatesDefault],

	computed: {
		hideAnfahrt() {
			return this.options &&
				Object.prototype.hasOwnProperty.call(this.options, 'hideAnfahrt')
				? this.options.hideAnfahrt
				: null;
		},
		showFunktion() {
			return this.options &&
				Object.prototype.hasOwnProperty.call(this.options, 'showFunktion')
				? this.options.showFunktion
				: true;
		},
		showFunktionOfKategorie() {
			return this.options &&
				Object.prototype.hasOwnProperty.call(
					this.options,
					'showFunktionOfKategorie',
				)
				? this.options.showFunktionOfKategorie
				: null;
		},
	},
};
</script>
